import React, {useEffect, useState } from "react";
import './ExpenseListInput.css';


const ExpenseListInput = (props) => {
    const [morgage, setMorgage] = useState("")
    const { expenses } = props;

    const expenseValuesList = [
        {id: 1, name: 'Morgage'}
    ]

    useEffect(() => {
        expenses.indexOf('Morgage') !== -1 ? setMorgage('Mortgage') : setMorgage("No")
        expenses.indexOf('Rent')
        expenses.indexOf('Utilities')
        expenses.indexOf('Property Tax')
        expenses.indexOf('Education')
        expenses.indexOf('Wi-Fi')
        expenses.indexOf('Cell Phone')
        expenses.indexOf('Car Payments')
        expenses.indexOf('Groceries')
        expenses.indexOf('Holiday/Travel')
        expenses.indexOf('Childcare')
        expenses.indexOf('Pet Care')
        expenses.indexOf('Health & Fitness')
        expenses.indexOf('Debt')
        expenses.indexOf('Entertainment & Recreation')
        expenses.indexOf('Personal Spending')
        expenses.indexOf('Home Maintenance')
        expenses.indexOf('Annual Subscriptions & Memberships')
        expenses.indexOf('RESP')
        expenses.indexOf('Other')

    }, [])
    
    return (
        <div className="expenses-list-css">
            <table>
                {morgage}
            </table>
        </div>
    )
};

export default ExpenseListInput;